/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { CSSProperties, useMemo } from "react"
import { StyledTable } from "baseui/table-grid"

import { TableStyles_Types, CreateTableStyle, SelectFieldOption_Values } from "../../Definitions"
import { ColumnPinningPosition, flexRender, Row, RowData, Table } from "@tanstack/react-table"
import { getTableContent } from "./_Tables/getTableContent"
import { convertPxValueToNumber, getWidthIfPinned, LEFT_FROZEN_TABLE_WIDTH, RIGHT_FROZEN_TABLE_WIDTH } from "./_Tables/getTableStyles"
import { headerOrFooterKey, renderHeaderAndFooter } from "./_Tables/getTableHeader"

interface TableListProps {
  tableType?: TableStyles_Types,
  table: Table<any>,
  emptyText: string,
  renderFooter?: boolean
}

export interface IdentifiableRow {
  id: number
}

export interface TableList_PropHandles {
  changed: {row:number,col:number, value:any}[],
}

declare module "@tanstack/react-table" {
  interface TableMeta<TData extends RowData> {
    updateData: (rowIndex: number, columnId: string, value: string | number | boolean | SelectFieldOption_Values | undefined, row: Row<TData>) => void;
    deleteRow: (rowId: number) => void;
    allowDeleteRowCheck?: (row: Row<TData>) => boolean;
    checkRow?: (rowId: number) => void;
  }
  interface ColumnMeta<TData extends RowData, TValue> {
    width?: string;
  }
}

export const ReactiveTable = ({ tableType, table, emptyText, renderFooter=true }: TableListProps) => {
  const { tableStyle, bodyCellStyle } = CreateTableStyle(tableType);

  const headers = table.getHeaderGroups().flatMap((headerGroups) => (headerGroups.headers));
  const rows = table.getRowModel().rows;
  const {columnWidth, columnWidthNumber} = headers.reduce((accumulator, header) => {
    const value = getWidthIfPinned(header.column.getIsPinned(), header.column.columnDef.meta?.width)
    accumulator.columnWidth.push(value);
    accumulator.columnWidthNumber.push(convertPxValueToNumber(value));
    return accumulator
  }, {columnWidth: [] as string[], columnWidthNumber: [] as number[]});

  const tableContent = getTableContent(rows, emptyText, bodyCellStyle, columnWidthNumber, tableType ? tableType : TableStyles_Types.primaryTable);
 
  const gridTemplateColumns = columnWidth.reduce((acc, val) => {
    return (acc + val);
  }, "")

  return (
  <StyledTable
    style={tableStyle as CSSProperties}
    role="grid"
    $gridTemplateColumns={gridTemplateColumns}
  >
    <div role="columnheader" key="header" style={{ display: "contents" }}>
      {/* {renderHeaderAndFooter(headers, headerOrFooterKey.header, columnWidthNumber, tableType ? tableType : TableStyles_Types.primaryTable)} */}
        {headers.map((header) => {
          return flexRender(header.column.columnDef.header, header.getContext())
        })}
    </div>
    <div key="tableBody" role="tablist" style={{ display: "contents"}}>
      {tableContent}
    </div>
   {renderFooter &&(<div role="rowheader" key="footer" style={{ display: "contents" }}>
      {
        renderHeaderAndFooter(headers, headerOrFooterKey.footer, columnWidthNumber,tableType ? tableType : TableStyles_Types.primaryTable)
      }
    </div>)}
  </StyledTable>
  );
}

